module.exports = __webpack_public_path__ + "media/assets/images/flags/so-9d6683e14e88adc78b4a9dfccb528dfd.svg";